module.exports = __webpack_public_path__ + "img/trainer2.1aff49fb.svg";